function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Layout from '@4c/layout';
import useFocusManager from '@restart/hooks/useFocusManager';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import createChainedFunction from 'react-bootstrap/createChainedFunction';
import FormControlErrorWrapper from './FormControlErrorWrapper';
import { useTheme } from './ThemeContext';
import useFormattedPlaceholder from './useFormattedPlaceholder';
import formStyles from './FormControls.module.scss';
const styles = require('./FormControlWithAddon-styles.module.scss');
const inputDefaultProps = {
  as: 'input'
};
const Input = React.forwardRef(({
  as: Component,
  placeholder,
  className,
  ...props
}, ref) => {
  const formattedPlaceholder = useFormattedPlaceholder(placeholder);
  return React.createElement(Component, _extends({}, props, {
    ref: ref,
    placeholder: formattedPlaceholder,
    className: classNames(className, styles.input)
  }));
});
Input.defaultProps = inputDefaultProps;
const propTypes = {
  /** The visual style of the input */
  theme: PropTypes.oneOf(['dark', 'hero', 'light']),

  /** A css class added to the input component */
  inputClassName: PropTypes.string,

  /** Visually style the control as invalid */
  invalid: PropTypes.bool,

  /** The HTML input type. */
  type: PropTypes.string
};
const defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  inputAs: Input
};
/**
 * An `input` with an action button overlayed.
 */

const FormControlWithAddon = React.forwardRef(({
  invalid,
  theme: propsTheme,
  className,
  inputClassName,
  addon,
  as,
  inputAs: InputComponent,
  meta,
  ...props
}, ref) => {
  const [focused, setFocus] = useState(false);
  const theme = useTheme(propsTheme);
  const {
    onFocus,
    onBlur
  } = useFocusManager({
    isDisabled: () => props.disabled,
    onChange: setFocus
  });
  return React.createElement(FormControlErrorWrapper, {
    className: className,
    invalid: invalid == null && meta ? meta.invalid : invalid
  }, React.createElement(Layout, {
    as: as,
    align: "center",
    justify: "space-between",
    className: classNames(styles.addon, formStyles[theme], focused && styles.focus, props.disabled && formStyles.disabled)
  }, React.createElement(InputComponent, _extends({
    ref: ref,
    className: inputClassName
  }, props, {
    onFocus: createChainedFunction(onFocus, props.onFocus),
    onBlur: createChainedFunction(onBlur, props.onBlur)
  })), addon));
});
FormControlWithAddon.propTypes = propTypes;
FormControlWithAddon.defaultProps = defaultProps;
FormControlWithAddon.Input = Input;
export default FormControlWithAddon;